import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: 'img[appFallbackImage]'
})
export class FallbackImageDirective {
  @Input() appFallbackImage: string = 'assets/img/school/logo.png';
  
  constructor(private eRef: ElementRef) { }

  @HostListener('error')
  loadFallbackOnError() {
    const element: HTMLImageElement = this.eRef.nativeElement;
    // Set to fallback image, only if not already fallback to avoid infinite loop
    if (!element.src.includes(this.appFallbackImage)) {
      element.src = this.appFallbackImage;
    }
  }
}
